import { Link } from 'react-router'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { UserAvatar } from '@/components/ui/user-avatar'
import { type StaffUser, staffUserName } from '@/models/user'

export function StaffUserHeader({ staffUser }: { staffUser: StaffUser }) {
  const name = staffUserName(staffUser)
  return (
    <div className="flex items-center gap-4">
      <UserAvatar name={name} src={staffUser.avatar} className="size-14" fallbackClassName="text-lg" />
      <div className="flex min-w-0 flex-col gap-1">
        <h1 className="truncate text-2xl font-semibold">{name}</h1>
        <p className="text-muted-foreground truncate text-sm">{staffUser.email}</p>
        <div className="flex flex-wrap gap-1.5">
          {staffUser.isCaiAdmin && <Badge variant="outline">Cai Labs</Badge>}
          {staffUser.isStaff && <Badge variant="outline">Staff</Badge>}
          {staffUser.receivesLeadAssignments && <Badge variant="outline">In lead rotation</Badge>}
        </div>
      </div>
      <Button variant="outline" asChild className="ml-auto">
        <Link to={`/insure/internal/my-pipeline?rep=${staffUser.id}`}>My Pipeline</Link>
      </Button>
    </div>
  )
}
